<template>
  <div @click.self="closeModal" class="modalContainer">
    <div class="modalWrapper">
      <div @click="closeModal" class="close">
        <img src="@/assets/icons/close.svg" alt="close" />
      </div>
      <h2>Clear Cart</h2>
      <p>
        Are you sure you want to remove all items from your cart? <br />
        This action cannot be undone.
      </p>
      <p class="feedback error" v-if="error.status">{{ error.message }}</p>

      <div class="buttonContainer">
        <button @click="closeModal" :disabled="clearCartButtonLoader" class="secondaryButtons">Cancel</button>

        <button @click="clearCart" :disabled="clearCartButtonLoader">
          <div v-if="clearCartButtonLoader" class="loader buttonLoader"></div>
          <template v-else>Clear Cart</template>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

import modalMixins from '@/mixins/modalMixins.js'

export default {
  data() {
    return {
      error: {
        status: false,
        message: '',
      },
    }
  },
  props: ['item', 'clearCartButtonLoader'],
  mixins: [modalMixins],
  computed: {
    ...mapState(['buttonLoader']),
  },
  methods: {
    ...mapMutations(['SET_BUTTON_LOADER', 'SET_TOASTER', 'SET_COOKIES']),
    closeModal() {
      this.$emit('closeModal')
    },
    clearCart() {
      this.$emit('clearCart')
    },
  },
}
</script>

<style src="@/assets/css/Modals/ItemModals/ClearCart.css" scoped></style>
